import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';

const useHandleActionClick = (kycStatus, setModalAction) => {
    const navigate = useNavigate();
    const { validateFreezedCurrencies, handleTransactionModalLogic } = useJunoCommonFunctions();

    return useCallback(
        action => {
            if (action === 'bulkPay') {
                navigate('/client/bulk-payment');
                return;
            }

            handleTransactionModalLogic(kycStatus, () =>
                validateFreezedCurrencies(action, () => setModalAction(action)),
            );
        },
        [
            kycStatus,
            navigate,
            validateFreezedCurrencies,
            handleTransactionModalLogic,
            setModalAction,
        ],
    );
};

export default useHandleActionClick;
